(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-event-lookbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ng-event-lookbook')) {
    customElements.define('ng-event-lookbook', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        if (new URLSearchParams(location.search).has('event')) { this.hidden = true; return; }
        this.controller = new AbortController();
        const { signal } = this.controller;
        const rail = this.querySelector('[data-lookbook-rail]');
        const previous = this.querySelector('[data-lookbook-previous]');
        const next = this.querySelector('[data-lookbook-next]');
        const counter = this.querySelector('[data-lookbook-counter]');
        const items = Array.from(rail.children);
        const players = Array.from(this.querySelectorAll('video'));
        this.players = players;
        this.querySelector('.ng-lookbook__controls').hidden = false;
        counter.hidden = false;
        const step = () => items[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
        const update = () => {
          const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
          previous.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollLeft >= maximum - 2;
          const position = Math.min(items.length, Math.max(1, Math.round(rail.scrollLeft / step()) + 1));
          counter.textContent = `${String(position).padStart(2, '0')} / ${items.length}`;
        };
        const move = (direction) => rail.scrollBy({ left: direction * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        rail.addEventListener('scroll', update, { passive: true, signal });
        rail.addEventListener('keydown', (event) => {
          if (event.target !== rail || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') rail.scrollTo({ left: event.key === 'Home' ? 0 : rail.scrollWidth });
          else move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        const matchPastCards = () => {
          const pastRail = document.querySelector('[data-ng-past-rail]');
          const pastCard = pastRail?.querySelector('.ng-event-overview-card:not([hidden])');
          if (pastCard) {
            const { width, height } = pastCard.getBoundingClientRect();
            if (width > 0 && height > 0) {
              this.style.setProperty('--ng-lb-card-width', `${width}px`);
              this.style.setProperty('--ng-lb-media-height', `${height}px`);
            }
          }
          update();
        };
        this.resizeObserver = new ResizeObserver(matchPastCards);
        this.resizeObserver.observe(rail);
        const pastCard = document.querySelector('[data-ng-past-rail] .ng-event-overview-card');
        if (pastCard) this.resizeObserver.observe(pastCard);
        matchPastCards();
        players.forEach((video) => {
          const frame = video.closest('.ng-lookbook__media');
          const button = frame.querySelector('[data-lookbook-play]');
          const error = frame.parentElement.querySelector('[data-lookbook-error]');
          video.controls = false;
          button.hidden = false;
          button.addEventListener('click', async () => {
            error.hidden = true;
            try { await video.play(); }
            catch { video.controls = true; button.hidden = true; error.hidden = false; }
          }, { signal });
          video.addEventListener('play', () => {
            players.forEach((other) => { if (other !== video) other.pause(); });
            video.controls = true;
            frame.classList.add('is-playing');
            button.hidden = true;
          }, { signal });
          video.addEventListener('ended', () => { frame.classList.remove('is-playing'); button.hidden = false; }, { signal });
        });
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach(({ target, intersectionRatio }) => { if (intersectionRatio < .25) target.pause(); });
        }, { threshold: .25 });
        players.forEach((video) => this.videoObserver.observe(video));
        document.addEventListener('visibilitychange', () => { if (document.hidden) players.forEach((video) => video.pause()); }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target)) event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, { signal });
      }
      disconnectedCallback() {
        this.players?.forEach((video) => video.pause());
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.videoObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
